import { PnlBreakdown } from "../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import {
  CustomerJsonType,
  FlightDashboardLinkType,
  WorkScheduleConfig,
  WorkScheduleShift,
} from "../types";
import { atom, useAtom } from "jotai";

// jotai vs zustand https://github.com/pmndrs/jotai/issues/13
// jotai + typescript https://docs.pmnd.rs/jotai/guides/typescript
// "jotai is bottom-up, like recoil; zustand is top-down, like redux
export const pnlBreakdownDataAtom = atom<PnlBreakdown | null>(null);
export const pnlBreakdownsByProcessAtom = atom<PnlBreakdown[]>([]);
export const pnlBreakdownsBySKUAtom = atom<PnlBreakdown[]>([]);
export const pnlBreakdownsByShiftAtom = atom<PnlBreakdown[]>([]);
export const pnlBreakdownByShiftAndProcessAtom = atom<PnlBreakdown[]>([]);
export const customerJsonAtom = atom<CustomerJsonType | null>(null);
export const workScheduleConfigListJsonAtom = atom<WorkScheduleConfig[] | null>(
  null
);
export const workScheduleShiftListJsonAtom = atom<WorkScheduleShift[] | null>(
  null
);
export const flightDashboardLinksAtom = atom<FlightDashboardLinkType[]>([]);

export function useFlightDashboardLink(machemetryId: string) {
  const [flightDashboardLinks] = useAtom(flightDashboardLinksAtom);
  return (
    (flightDashboardLinks.find(mapping => mapping.machemetryId === machemetryId)
      ?.dashboardLink ??
      null) ||
    ""
  );
}

export const lastNWeekDataAtom = atom<PnlBreakdown[]>([]);
export const lastNMonthDataAtom = atom<PnlBreakdown[]>([]);

export const isStorybookAtom = atom<boolean>(false);
